import { render } from "./ScreenFour.vue?vue&type=template&id=36626086&scoped=true"
import script from "./ScreenFour.vue?vue&type=script&lang=js"
export * from "./ScreenFour.vue?vue&type=script&lang=js"

import "./ScreenFour.vue?vue&type=style&index=0&id=36626086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36626086"]])

export default __exports__